import { Box, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material"
import { ILanguageItem } from "./LanguageRender"
import { useState } from "react"
import { useTranslation } from "react-i18next"

export interface ILanguageRenderItem {
    el: ILanguageItem
}

export const LanguageRenderItem : React.FC<ILanguageRenderItem> = ({
    el
}) => {
    const { i18n } = useTranslation();
    
    return (
        <Box
            width="346px"
            height="39px"
            display="flex"
            alignItems="center"
            border="1px solid #2D2D2D1A"
            borderRadius="4px"
            justifyContent="space-between"
            padding="10px"
        >   
            <Typography
                fontSize="14px"
                color="#2d2d2d"
            >
                { el.title }
            </Typography>
            <Radio
                value={el.value}
                checked={i18n.language == el.value}
                onChange={e => {
                    el.onClick()
                }}
            />
        </Box>
    )
}